import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import moment from 'moment';

import { mapOrderField } from '../../models/Order';
import Table from '../common/Table';
import OrderStatusCell from './OrderStatusCell';

const useStyles = makeStyles((theme) => {
  return {
    workspaceName: {
      color: theme.palette.primary.main,
    },
  };
});

export default ({ orders, total, onCriteriaChange, searchCriteria, onOrderClick }) => {
  const columns = [
    {
      label: 'Registered Date',
      name: 'createdAt',
      options: {
        customBodyRender: (value, meta) => {
          return moment(value).format('MM/DD/YYYY - HH:mm');
        },
      },
    },
    {
      label: 'Customer',
      name: 'name',
    },
    {
      label: 'Email Address',
      name: 'email',
    },
    {
      label: 'Workspace',
      name: 'workspaceName',
      options: {
        customBodyRender: (value) => {
          return <span className={classes.workspaceName}>{value}</span>;
        },
      },
    },
    {
      label: 'Clinic',
      name: 'clinicCode',
      options: {
        customBodyRender: (value) => {
          return <span>{value || ''}</span>;
        },
      },
    },
    {
      label: 'Package',
      name: 'packageName',
    },
    {
      label: 'Status',
      name: 'status',
      options: {
        customBodyRender: (value, meta) => {
          const color = meta.rowData[8];
          return <OrderStatusCell status={value?.label || ''} color={color} />;
        },
      },
      sort: true,
    },
    {
      label: 'GCLID',
      name: 'gclid',
      options: {
        customBodyRender: (value) => value || '-',
      },
    },
    {
      label: '',
      name: 'statusColor',
      options: { display: false },
    },
  ];

  const defaultOptions = {
    count: total,
    onRowSelectionChange: (currentRowsSelected) => {
      const { id } = orders[currentRowsSelected[0].index];
      onOrderClick(id);
    },
    onTableChange: (action, tableState) => {
      const criteria = {};
      switch (action) {
        case 'sort':
          criteria.orderType = tableState.sortOrder.direction.toUpperCase();
          criteria.orderField = mapOrderField(tableState.sortOrder.name);
          break;
        case 'changePage':
          criteria.page = tableState.page;
          break;
        case 'changeRowsPerPage':
          criteria.limit = tableState.rowsPerPage;
          setTableOptions({
            ...tableOptions,
            rowsPerPage: tableState.rowsPerPage,
          });
          break;
        default:
          return;
      }
      onCriteriaChange(criteria);
    },
    page: searchCriteria?.page,
    serverSide: true,
  };

  useEffect(() => {
    setTableOptions({
      ...tableOptions,
      count: total,
      onRowSelectionChange: (currentRowsSelected) => {
        const caseStudy = orders[currentRowsSelected[0].index];
        onOrderClick(caseStudy);
      },
      page: searchCriteria?.page,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, orders, searchCriteria]);

  const [tableOptions, setTableOptions] = useState(defaultOptions);

  const classes = useStyles();

  return <Table className="small-padding-table" columns={columns} data={orders || []} options={tableOptions} />;
};
